import * as React from 'react'
import { Link } from 'react-router-dom'
type Props = {
  disabled?: boolean
  to: string | { pathname: string }
  onClick?: (...args: Array<any>) => any
  children?: React.ReactNode
  className?: string
}

/**
 * A wrapper around react-router's Link component that allows you to disable router links
 * @param disabled - Whether the link should be disabled (defaults to false)
 * @param to - The route to navigate to, can be a string or path object
 * @param onClick - Optional click handler function
 * @param children - The content to render inside the link
 * @param className - Optional CSS class name
 * @returns A Link component that can be disabled
 */
const RouteLink = ({
  disabled,
  to,
  onClick,
  children,
  ...rest
}: Props): React.ReactNode => {
  if (disabled) return <span {...rest}>{children}</span>
  return (
    <Link {...rest} to={to} onClick={onClick}>
      {children}
    </Link>
  )
}

export default RouteLink
